module.exports = __webpack_public_path__ + "assets/images/pages/ebaysocial/ebaysocial-1.png?a54e4994";